import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const notificationsRequest = createRequest(constants.notifications);
export const notificationsSuccess = createSuccess(constants.notifications);
export const notificationsFailure = createFailure(constants.notifications);

export const requestNotifications = notificationsRequest;
